const getLeftOffset = left => {
  if (left + 165 > window.innerWidth) return window.innerWidth - 305;
  if (left < 165) return 10;
  return left - 135;
};

export default getLeftOffset;
